import { Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import axiosService from '../../../utils/AxiosService';
import Input from '../../FormComponents/Input'
import { toastError, toastSuccess } from '../../FormComponents/Toasts';

export default function ForgottenPassword() {
  const emailSchema = Yup.object().shape({
    email: Yup.string()
    .strict()
    .required('Required')
    .email('Invalid email')
  });

  const handleSubmit = ({ email }) => {
    axiosService.post(`/api/project_manager/password/forgotten_password_email`, { project_manager: { email }})
    .then(() => {
      toastSuccess('Email sent to you with instructions')
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <div className='flex h-screen w-screen bg-rb-grey relative overflow-hidden'>
      <img src="/static/background_images/login-shape-left.png" alt="bottom corner lines" className='absolute -bottom-40 -left-40 -z-5' />
      <img src="/static/background_images/login-shape-right.png" alt="top corner lines" className='absolute -top-40 -right-40 -z-5' />
      <div className="m-auto">
        <div className='flex justify-center align-center mb-5 z-5'>
          <img src="/static/reachbird_logo.png" alt="Logo" className="h-7" />
          <h1 className='pl-2 text-center align-middle text-2xl font-bold'>Reachbird</h1>
        </div>
        <div
          className='flex flex-col justify-between align-center bg-white rounded-lg p-6 relative'
          style={{ height: 500, width: 320 }}
        >
          <Formik
            initialValues={{ email: '' }}
            validationSchema={emailSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, handleBlur, handleChange, values }) => (
              <Form>
                <div className="relative">
                  <Input
                    error={touched.email && errors.email}
                    label="Email"
                    name="email"
                    noLabelPadding
                    placeholder="Email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                  />
                </div>
                <div className="relative mt-5">
                  <button
                    type="submit"
                    className="submit text-left w-full text-white bg-rb-green rounded-lg w-full py-2 text-center active:shadow-outer active:shadow"
                  >
                    Send a reset password email
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}